import { queryOptions, useMutation, useQueryClient } from '@tanstack/react-query';
import { api, failure } from './api.js';
const ownSessionsKey = ['me', 'sessions'];
/** Where the person is signed in, in this app (ADR-005). */
export const ownSessionsQuery = queryOptions({
    queryKey: ownSessionsKey,
    queryFn: async () => {
        const { data, error, response } = await api.GET('/api/v1/me/sessions');
        if (!data)
            throw failure('listOwnSessions', error, response.status);
        return data;
    },
});
/** The own ways to sign in, as the identity provider keeps them (ADR-033). */
export const ownCredentialsQuery = queryOptions({
    queryKey: ['me', 'credentials'],
    queryFn: async () => {
        const { data, error, response } = await api.GET('/api/v1/me/credentials');
        if (!data)
            throw failure('listOwnCredentials', error, response.status);
        return data;
    },
});
/** Signs out one other device, or - without an id - every other one. */
export function useEndSessions() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (sessionId) => {
            const { error, response } = sessionId === null
                ? await api.DELETE('/api/v1/me/sessions')
                : await api.DELETE('/api/v1/me/sessions/{sessionId}', {
                    params: { path: { sessionId } },
                });
            if (!response.ok) {
                throw failure(sessionId === null ? 'endOtherSessions' : 'endOwnSession', error, response.status);
            }
        },
        onSettled: () => queryClient.invalidateQueries({ queryKey: ownSessionsKey }),
    });
}
//# sourceMappingURL=own-sessions.js.map